<main>
  <div class="header p-3">
    <img src="assets/images/logo/cedlab-logo.png" alt="CedLab">
  </div>

  <div class="container message-panel flex-column" *ngIf="confirmationEmailStatus.isSuccesfully()">
    <img class="logo-small mb-5" src="assets/images/logo/cedlab-logo-small.png" alt="CedLab">
    <h1>Registrazione Completata!</h1>
    <h3>Congratulazioni, il tuo account CedLab ora è attivo</h3>
    <br>
    <a mat-flat-button href="https://cedlabpro.it/home">Accedi</a>
  </div>

  <div class="container message-panel flex-column" *ngIf="confirmationEmailStatus.isFailed()">
    <img class="logo-small mb-5" src="assets/images/logo/cedlab-logo-small.png" alt="CedLab">

    <ng-container *ngIf="linkNotValid">
      <h3>Il link non è valido</h3>
      <h3>Riprova</h3>
    </ng-container>

    <ng-container *ngIf="userNotFound">
      <h3>La tua registrazione non è andata a buon fine</h3>
      <h3>Si prega di ripetere la registrazione</h3>
    </ng-container>

    <ng-container *ngIf="linkIsExpired">
      <h3>Il link di registrazione è scaduto</h3>
      <h3>Un nuovo link di conferma sarà inviato alla tua mail.</h3>
    </ng-container>

    <ng-container *ngIf="generalError">
      <h3>Errore nella conferma della mail</h3>
      <h3>Un nuovo link di conferma sarà inviato alla tua mail.</h3>
    </ng-container>
  </div>

  <div *ngIf="confirmationEmailLoader.isActive()" class="container message-panel">
    <div class="lds-dual-ring"></div>
  </div>
</main>